import classnames from 'classnames'
import React from 'react'

type VariantAttr = 'success' | 'info' | 'danger' | 'purple-info' | 'gray-info'

type Props = {
  children: React.ReactNode
  variant: VariantAttr
  className?: string
}

const styles: any = {
  fontSize: '1.6rem',
  fontWeight: 'normal',
  letterSpacing: '0.02rem',
  lineHeight: 1.5,
  width: '100%',
}

const Alert = ({ children, variant, className }: Props) => {
  if (variant === 'danger') {
    return <span className="u-fs-14 u-color-black">{children}</span>
  }

  return (
    <div
      className={classnames('c-box u-mb-0', className, {
        't-light-purple': variant === 'purple-info',
        't-light-gray': variant === 'gray-info',
        't-light-green': variant === 'success',
        't-light-blue': variant === 'info',
      })}>
      <div style={styles}>{children}</div>
    </div>
  )
}

export default Alert
